// extracted by mini-css-extract-plugin
export default {"cls1":"Loading-FieldSkeleton_cls1__8y967","cls2":"Loading-FieldSkeleton_cls2__vR0pf Loading-FieldSkeleton_cls1__8y967"};